const fileImport = {
  uat62: require('./config.uat62.js'),
  uat52: require('./config.uat52.js'),
  production: require('./config.production.js'),
  island: require('./config.island.js'),
  prodGcp: require('./config.prodGcp.js'),
  prodReplica: require('./config.prodReplica.js'),
  prodGcpReplica: require('./config.prodGcpReplica.js'),
  sit118: require('./config.sit118.js'),
  preview: require('./config.preview.js'),
  uatAutomation: require('./config.uatAutomation.js')
};

const isNode = require('../ajio-util/isNode')();

function init(env, options = {}) {
  const { excludes } = options;
  // let baseConfig = {};
  let envConfig = {};
  try {
    // Removing base conifg usage as its always empty and currenlty of no use
    // baseConfig = require('./config.js');
    envConfig = fileImport[env] || {};
    if (isNode) {
      if (typeof window === 'undefined') {
        global.window = new Object();
        global.isNode = true;
      }
      console.log(`Configuration files taken:- config.${env}.js, config.js`);
    }
  } catch (e) {}
  const results = {
    endpoints: envConfig.endpoints || {},
    properties: envConfig.properties || {},
    getProperty,
    getEndpoint
  };

  if (excludes && Array.isArray(excludes) && excludes.length > 0) {
    excludes.forEach(exclude => {
      if (results[exclude]) {
        delete results[exclude];
      }
    });
  }
  return results;
}

function getProperty(name) {
  this.properties[name];
}

function getEndpoint(name) {
  this.properties[name];
}

module.exports = {
  init
};